<script setup lang="ts">
import { computed, onMounted, onUnmounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Lucide from "@/components/Base/Lucide";
import { useAuthStore } from "@/stores/auth";
import { useChatUnreadStore } from "@/stores/chatUnread";
import { storeToRefs } from "pinia";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const auth = useAuthStore();
const unread = useChatUnreadStore();
const { total, personal, board, badgeLabel } = storeToRefs(unread);

const isStaff = computed(() =>
  ["ADMIN", "TECNICO"].includes(String(auth.user?.role || ""))
);

const title = computed(() => {
  if (total.value <= 0) return t("chat.header_title");
  return t("chat.header_unread", { count: total.value });
});

const openChat = () => {
  if (isStaff.value && board.value > 0) {
    router.push({ name: "chat" });
    return;
  }
  if (isStaff.value && personal.value <= 0) {
    router.push({ name: "chat" });
    return;
  }
  router.push({ name: "family-chat" });
};

watch(
  () => route.name,
  (name) => {
    if (name === "chat" || name === "family-chat") {
      unread.onRoomViewed();
    }
  }
);

onMounted(() => unread.startPolling());
onUnmounted(() => unread.stopPolling());
</script>

<template>
  <a
    href=""
    class="relative p-2 rounded-full hover:bg-slate-100 dark:hover:bg-darkmode-400"
    :title="title"
    :aria-label="title"
    @click.prevent="openChat"
  >
    <Lucide icon="MessagesSquare" class="w-[18px] h-[18px]" />
    <span
      v-if="total > 0"
      class="absolute -top-0.5 -right-0.5 min-w-[1.1rem] h-[1.1rem] px-1 flex items-center justify-center rounded-full bg-danger text-[10px] font-semibold leading-none text-white"
    >
      {{ badgeLabel }}
    </span>
  </a>
</template>
